import axios from "axios";
import { MediaLibraryConfig, StreamLibraryConfig } from "../types";
import { BlockCollectionConfig } from "../types/ConfigTypes";

class ConfigService {
    async getLibraryConfig(clientId: string): Promise<{
        mediaConfig: MediaLibraryConfig;
        streamConfig: StreamLibraryConfig;
    }> {
        try {
            const [mediaRes, streamRes] = await Promise.all([
                axios.get(`${process.env.REACT_APP_MEDIA_SERVICE_ENDPOINT}/library-config/${clientId}`, { params: { libraryId: 1 } }),
                axios.get(`${process.env.REACT_APP_MEDIA_SERVICE_ENDPOINT}/library-config/${clientId}`, { params: { libraryId: 2 } }),
            ]);

            return {
                mediaConfig: mediaRes.data.data,
                streamConfig: streamRes.data.data,
            };
        } catch (error: any) {
            console.error("Error fetching merged library config", error);
            throw error;
        }
    }

    async getLibraryTemplates(clientId: string, bypassCache = false): Promise<BlockCollectionConfig> {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_MEDIA_SERVICE_ENDPOINT}/library-template/${clientId}`,
                bypassCache ? { params: { bypassCache: "true" } } : {}
            );

            return response.data.data;
        } catch (error: any) {
            console.error("Error fetching library templates", error);
            return {
                clientId,
                order: [],
                templateIds: [],
            }
        }
    }
}

export const configService = new ConfigService();
